/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-prototype-builtins */

import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Rnd } from 'react-rnd';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { closeIconBlack } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import './split.scss';
import { fetchFolderStructure } from '../my-projects/data/FolderData'; // eslint-disable-next-line
import Folder from '../my-projects/FileExplorer';
import useTraverseTree from '../my-projects/hooks/use-traverse-tree';
// eslint-disable-next-line
let handleTextChange_onAction;

const SaveFiles = (props) => {
  const { visibleSaveFiles, handleCloseSaveFiles, translateObject, text, setText, onSave, onSave_saveButton, setSourcePath, openModelPopUp } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [, setShowFiles] = useState(true);
  const { insertNode, deleteNode, renameNode, moveNode } = useTraverseTree();
  const [explorerData, setExplorerData] = useState([]);
  const [fileName, setFileName] = useState('winfiles');
  useEffect(() => {
    if (fileName) {
      setSourcePath(fileName);
      localStorage.setItem('folderStr', fileName);
    }
  }, [fileName, setSourcePath]);

  useEffect(() => {
    const loadFolderStructure = async () => {
      try {
        const data = await fetchFolderStructure();
        if (data[0].items.map(o => o.name).includes('Bin'))
          data[0].items = data[0].items.filter(item => item.name !== 'Bin').concat(data[0].items.find(item => item.name === 'Bin'));
        setExplorerData(data);
      } catch (error) {
        // Handle error, maybe set an error state or show a notification
        // eslint-disable-next-line no-console
        console.error('Error loading folder structure:', error);
      }
    };
    loadFolderStructure();

    if (localStorage.getItem('folderPath')) {
      const fpath = localStorage.getItem('folderPath');
      setFileName(`winfiles/${fpath}`);
    }

  }, []);

  const handleTextChange = (e) => {
    const fullValue = e.target.value;
    const modifiedFileName = fileName.replace('winfiles', 'root');

    // const basePath = `${fileName}/`;
    const basePath = `${modifiedFileName}/`;

    // Ensure that the base path is not altered
    if (!fullValue.startsWith(basePath)) {
      return;
    }

    // Extract the new last segment
    const newText = fullValue.substring(basePath.length);
    setText(newText);
  };

  handleTextChange_onAction = (val, mode) => {

    if (mode === 'create') {
      // set only folder is created : if empty then dont set
      if (!(val === 'winfiles/')) {
        localStorage.setItem('folderStr', val);
        setFileName(val);
      }
    }
    else { // delete mode
      // eslint-disable-next-line
      if (fileName.includes(val)) {
        const ar = val.split('/');
        ar.pop();
        val = ar.join('/');
        setFileName(val);
      }
    }

  };

  const handleInsertNode = (folderId, item, isFolder) => {
    const finalTree = explorerData.map(tree => insertNode(tree, folderId, item, isFolder));
    setExplorerData(finalTree);
  };
  const handleDeleteNode = (nodeId) => {
    const finalTree = explorerData.map(tree => deleteNode(tree, nodeId));
    setExplorerData(finalTree);
  };
  const handleRenameNode = (nodeId, newName) => {
    const finalTree = explorerData.map(tree => renameNode(tree, nodeId, newName));
    setExplorerData(finalTree);
  };
  const handleMoveNode = (nodeId, targetFolderId) => {
    const finalTree = explorerData.map(tree => moveNode(tree, nodeId, targetFolderId));
    setExplorerData(finalTree);
  };
  const handleOnSave = () => {
    const trimmedText = text.trim();

    if (trimmedText.length <= 3) {
      // Show a warning if the filename is too short
      openModelPopUp('Please enter a valid filename', 'Warning', 'warning');
    } else {
      // Proceed with saving if the filename is valid
      // // onSave_saveButton();
      onSave(trimmedText);
      handleCloseSaveFiles();
    }
  };
  const selectLastSegment = (inputElement) => {
    setTimeout(() => {  // eslint-disable-next-line
      const value = inputElement.value;
      const lastSlashIndex = value.lastIndexOf('/') + 1;
      inputElement.setSelectionRange(lastSlashIndex, value.length);
    }, 0);
  };

  const modifiedFileName = fileName.replace('winfiles', 'root');

  return (
    // <Draggable handle='.split-box'
    //   cancel='.split-header-text, .no_drag, #drag-handle, #filled-hidden-label-small, .MuiButton-contained, .split-note-text'>
    <Modal hideBackdrop
      open={visibleSaveFiles}
      onClose={handleCloseSaveFiles}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="SaveFile-modal"
    >
      <Box>
        <Rnd
          default={{
            x: ((window.innerWidth / 2) - ((35 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((70 * (window.innerHeight / 100)) / 2)),
            width: '35%',
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          onResize={() => { }}
          // onResize={(e, direction, ref, delta, position) => { }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='30%'
          cancel='.no_drag,
          .SaveFile-header-text, #drag-handle, #filled-hidden-label-small, .MuiButton-contained'
          className='SaveFile-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='SaveFile-grid-container'>
            <Grid item xs={12} className='SaveFile-header-grid'>
              <div className='SaveFile-header-text rufusBld no_drag S_heading'>Save</div>
              <div className='SaveFile-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleCloseSaveFiles}
                    style={{ display: 'block' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='SaveFile-body-container'>
              <Box sx={{ width: '100%', typography: 'body1' }} className='mixer-box-container'>
                <div className='SaveFileFloderStructure'>
                  {explorerData.map((rootFolder) => (
                    <Folder
                      key={rootFolder.id}
                      handleInsertNode={handleInsertNode}
                      handleDeleteNode={handleDeleteNode}
                      handleRenameNode={handleRenameNode}
                      handleMoveNode={handleMoveNode}
                      setFileName={setFileName}
                      setShowFiles={setShowFiles}
                      explorer={rootFolder}
                      explorerData={explorerData}
                      isSave='Save'
                      isRoot
                    />
                  ))}
                </div>
              </Box>
              <Grid className='splitter-mixer-update-button' item xs={12}>
                <div className='note-item'>
                  <Grid container className='sansW4SeLig M_Regular'>
                    {/* <div className='span-3' style={{ position: 'unset' }}> */}
                    <input
                      id="filled-hidden-label-small"
                      variant="outlined"
                      type="text"
                      onFocus={(e) => selectLastSegment(e.target)}
                      name={text}
                      className='Form_Input_design'
                      value={`${modifiedFileName}/${text}`}
                      // onChange={handleNumberChange}
                      onChange={handleTextChange}
                      // onBlur={handleBlur}
                      style={{ width: '100%', paddingLeft: '5px', '& fieldset': { borderRadius: '22px' }, }}
                    />
                    {/* {streamValidation[`stream${obj.text}`] &&
                      (<div style={{ 'width': '200px' }} className='error-message-text no_drag'>
                        {translateObject('Stream Values should be between 0 and 1')}</div>)
                    } */}
                    {/* </div> */}
                  </Grid>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={12} sm={12}>
                    <div className="SaveFile-button">
                      <div className='apply-button'>
                        {/* <Button variant="contained" className="sansW4SeLig M_Bold Primary_Default_Button"
                          style={{ width: '120px' }}
                          disabled={buttonEnable}
                          size="small" onClick={handleUpdateApply}>
                          {translateObject('Apply')}
                        </Button> */}
                      </div>
                      <div className='cancel-ok-button'>
                        <Button variant="contained" className="sansW4SeLig M_Bold Secondary-Default_button"
                          size="small" style={{ width: '120px', marginRight: '15px' }} onClick={handleCloseSaveFiles}> {translateObject('Cancel')} </Button>
                        <Button variant="contained" className="sansW4SeLig M_Bold Primary_Default_Button"
                          size="small" style={{ width: '120px' }} onClick={handleOnSave}> {translateObject('Save')} </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default SaveFiles;
export { handleTextChange_onAction };